import React from 'react';
import { Link } from 'react-router-dom';
import { APP_NAME } from '../../constants';

const Footer = () => (
  <footer className="border-t border-gray-200 bg-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
      <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-xs text-gray-400 text-center sm:text-left">
          &copy; {new Date().getFullYear()} {APP_NAME}. All rights reserved.
        </p>
        <div className="flex items-center gap-4 text-xs text-gray-400">
          <Link to="/help" className="hover:text-gray-600 no-underline transition-colors">Help</Link>
          <Link to="/faq" className="hover:text-gray-600 no-underline transition-colors">FAQ</Link>
          <Link to="/become-seller" className="hover:text-gray-600 no-underline transition-colors">Sell on {APP_NAME}</Link>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
